export const SLPScoreRatingLang = {
    heart: 'قلب',
    person: 'کاربر',
    star: 'ستاره',
    flag: 'پرچم',
    circle: 'دایره',
    thumb_up: 'لایک',
};
